var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1547 3.488L12.512 5.84533M11.1547 2.488C11.4673 2.1754 11.8912 1.99978 12.3333 1.99978C12.7754 1.99978 13.1994 2.1754 13.512 2.488C13.8246 2.8006 14.0002 3.22458 14.0002 3.66667C14.0002 4.10875 13.8246 4.53273 13.512 4.84533L4.33333 14.024H2V11.6427L11.1547 2.488Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilOutline);
export default __webpack_public_path__ + "static/media/PencilOutline.656b689d91fc4d163602aa83d28d722c.svg";
export { ForwardRef as ReactComponent };